export default "__VITE_ASSET__CW1ScFQk__"